export const LANDING_PAGE_VARIANTS = {
  default: 'default',
  ehAndJam: 'ehAndJam',
};
